const employeeCostsMenu: any = {};

export default employeeCostsMenu;
